import React, { useContext } from 'react';
import { RouteChildrenProps } from 'react-router';
import { LocationDescriptorObject, Path, LocationState } from 'history';

export type HistoryPushOne<HistoryLocationState = LocationState> = (path: Path, state?: HistoryLocationState) => void;
export type HistoryPushTwo<HistoryLocationState = LocationState> = (
    location: LocationDescriptorObject<HistoryLocationState>
) => void;
export type HistoryPush = HistoryPushOne | HistoryPushTwo;

export interface AppRouteChildrenProps extends RouteChildrenProps {
    host: string;
    disableClientsideNavigation?: boolean;
}
const RouterContext = React.createContext<AppRouteChildrenProps>({} as AppRouteChildrenProps);

export const RouterProvider = RouterContext.Provider;

export default function useRouter() {
    return useContext(RouterContext);
}
